import { render, staticRenderFns } from "./HealthCheck45PsaThyroid.vue?vue&type=template&id=1e62ff99&scoped=true&"
import script from "./HealthCheck45PsaThyroid.vue?vue&type=script&lang=js&"
export * from "./HealthCheck45PsaThyroid.vue?vue&type=script&lang=js&"
import style0 from "./HealthCheck45PsaThyroid.vue?vue&type=style&index=0&id=1e62ff99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e62ff99",
  null
  
)

export default component.exports